module.exports = require("52-deck");


//////////////////
// WEBPACK FOOTER
// external "52-deck"
// module id = 7
// module chunks = 0